/**
 * The topbar's <h1> — the document's own heading, and what a screen reader
 * announces on arrival. The page's visible heading is the <h2> inside
 * PageHeader; these must not disagree.
 *
 * KEEP IN STEP WITH Sidebar's nav labels. Eight destinations were missing and
 * the fallback is the product's name, so Accounting, Activity log, Expenses,
 * Expense categories, Supplier payments, Purchase returns and Support each
 * announced themselves as "Voltra POS" — seven different screens with one
 * title. `/inventory/adjustments` was worse than missing: the prefix fallback
 * below matched `/inventory` and confidently said "Stock", while the page
 * itself said "Stock adjustments".
 *
 * Longest match wins, so the more specific path is listed above the prefix it
 * shares.
 */
export const TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/products': 'Products',
  '/categories': 'Categories',
  '/taxes': 'Tax Rates',
  '/inventory/adjustments': 'Stock adjustments',
  '/inventory': 'Stock',
  '/transfers': 'Transfers',
  '/suppliers': 'Suppliers',
  '/purchases': 'Purchases',
  '/purchase-returns': 'Purchase returns',
  '/customers': 'Customers',
  '/sales': 'Sales History',
  '/returns': 'Returns',
  '/tables': 'Tables',
  '/registers': 'Registers',
  '/reports': 'Reports',
  '/expenses': 'Expenses',
  '/expense-categories': 'Expense categories',
  '/supplier-payments': 'Supplier payments',
  '/accounting': 'Accounting',
  '/staff': 'Staff',
  '/roles': 'Roles',
  '/outlets': 'Outlets',
  '/settings/profile': 'Profile',
  '/settings/security': 'Security',
  '/settings': 'Settings',
  '/activity-log': 'Activity log',
  '/billing': 'Billing',
  '/support': 'Support',
}
